import Reflux from 'reflux';
import InviteWizardActions from 'actions/InviteWizard';
import Message from 'services/Message';

export default Reflux.createStore({
  listenables: [InviteWizardActions],
  data: {
    step: 1,
    selectedCourses: [],
    selectedGroups: [],
    selectedStudents: [],
    invitees: [],
    accessTime: null,
    endTime: null,
    tags: {}
  },
  getInitialState() {
    return this.data;
  },
  reset() {
    this.data = {
      step: 0,
      selectedCourses: [],
      selectedGroups: [],
      selectedStudents: [],
      invitees: [],
      accessTime: null,
      endTime: null,
      tags: {}
    };
    this.trigger(this.data);
  },
  restart() {
    this.data.step = 1;
    this.trigger(this.data);
  },
  onNext() {
    this.data.step = this.data.step + 1;
    this.trigger(this.data);
  },
  onPrevious() {
    if (this.data.step > 1) {
      this.data.step = this.data.step - 1;
      this.trigger(this.data);
    }
  },
  onSelectCourses(courses) {
    this.data.selectedCourses = courses;
    this.trigger(this.data);
  },
  onSelectGroups(groups) {
    this.data.selectedGroups = groups;
    this.trigger(this.data);
  },
  onSelectStudents(students) {
    this.data.selectedStudents = students;
    this.trigger(this.data);
  },
  onSetInvitees(invitees) {
    this.data.invitees = invitees;
    this.trigger(this.data);
  }
});



// WEBPACK FOOTER //
// ./src/js/stores/InviteWizard.js